module.exports = __webpack_public_path__ + "static/media/provider.da32f0f6.png";